import React from "react";
import styles from "./ModalStudentsAttending.module.scss";
import Modal from "../../components/Modal/Modal";
import Chip from "../Chip/Chip";

const ModalStudentsAttending = ({ modalRef, title, students }) => {
  return (
    <Modal
      title={title}
      ref={modalRef}
      buttonCloseText="CANCEL"
      buttonCloseOnClick={() => modalRef.current.hide()}
      onClose={() => modalRef.current.hide()}
      showCancelButton={false}
      showOkButton={false}
    >
      <div className={styles.listOfStudents}>
        {students &&
          students.map((student, index) => (
            <div key={index} className={styles.studentAtt}>
              <Chip {...student["user"]} />
              <div className={styles.studentFullName}>
                {student.user.firstName} {student.user.lastName}
              </div>
            </div>
          ))}
      </div>
    </Modal>
  );
};

export default ModalStudentsAttending;
